$(() => {
  $('.js-accordion').hide();
});
